import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import PropTypes from "prop-types";
import clsx from "clsx";
import { useDebounce } from "../../../../hooks/useDebounce";
import styles from "./NameInput.module.scss";
import { generateFavouriteName, isValidName } from "../../../../lib/string";

export const NameInput = ({ name = "", handleChange }) => {
  const { storedFavourites } = useSelector((state) => state.filter);
  // Local state for immediate UI updates
  const [localName, setLocalName] = useState(
    name ? name : generateFavouriteName("", storedFavourites)
  );
  // Debounce the local name value
  const debouncedName = useDebounce(localName, 300);

  // Call handleChange with debounced value
  useEffect(() => {
    if (debouncedName !== name) {
      handleChange(debouncedName);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedName]);

  useEffect(() => {
    setLocalName(name);
  }, [name]);

  const handleInputChange = (e) => {
    // Update local state immediately for responsive UI
    setLocalName(e.target.value);
  };
  const isEmpty = localName === "";
  const className = clsx(styles.nameInputContainer, {
    [styles.valid]: !isEmpty && isValidName(localName),
    [styles.invalid]: !isEmpty && !isValidName(localName),
  });

  return (
    <div className={className}>
      <label htmlFor="name" className={styles.changeNameLabel}>
        Name
      </label>
      <input
        type="text"
        id="name"
        className={styles.changeNameInput}
        value={localName}
        onChange={handleInputChange}
      />
    </div>
  );
};

NameInput.propTypes = {
  name: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
};
